import { useCallback, useState } from 'react';
import useApi from './useApi';
import { ChangeSet } from '../types/ChangeSetTypes';
import { ChangeSetStatusEnum } from '../enums/ChangeSetStatusEnum';
import { useAppSettings } from '../hooks/useAppSettings';

export default () => {
    const { settings: appSettings } = useAppSettings();
    const { postApiData } = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const reviewChangeSet = useCallback(
        async (changeSet: ChangeSet) => {
            try {
                setLoading(true);
                setError(null);
                setSuccess(false);

                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    throw new Error('API URL not configured in app settings');
                }

                const fullUrl = `${apiUrl}ChangeSet`;

                // Build body matching the C# ChangeSet model expected by the Portal API
                const body = {
                    Id: changeSet.id,
                    ReviewStatus: ChangeSetStatusEnum.Reviewed,
                };

                console.log('[useReviewChangeSet] POST:', fullUrl, body);

                const response = await postApiData({
                    endpoint: fullUrl,
                    data: body,
                });

                console.log('[useReviewChangeSet] Success:', response);
                setSuccess(true);
                setLoading(false);
                return response;
            } catch (err: any) {
                console.error('[useReviewChangeSet] Failed to review change set:', err);
                const errorMessage = err.response?.data?.message || err.message || 'Failed to confirm review';
                setError(errorMessage);
                setLoading(false);
                throw err;
            }
        },
        [appSettings, postApiData]
    );

    const resetState = useCallback(() => {
        setError(null);
        setSuccess(false);
    }, []);

    return {
        reviewChangeSet,
        loading,
        error,
        success,
        resetState,
    };
};
